import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import swal from 'sweetalert2';
import { DataService } from '../../../../services/data.service';
import { IssueService } from '../../../../services/issue.service';
import { getQueryParamFromAncestorRoute } from '../../../../utilities/route.utilities';

@Component({
    selector: 'issue-no-consumption-grid-item',
    templateUrl: './issues-no-consumption-grid-item.component.html',
})
export class IssuesNoConsumptionComponent implements AfterViewInit, OnDestroy {

    clientId: number;
    subscriptions: any[] = [];
    data: any[] = [];
    page: number = 1;
    totalPages: number = 1;
    pageSize: number = 10;
    siteId: number;

    constructor(private issueService: IssueService,
        private route: ActivatedRoute,
        private router: Router,
        private dataService: DataService) { }

    ngAfterViewInit() {
        this.subscriptions.push(this.route.queryParams.subscribe(queryParams => {
            this.onInitialise();
        }));
    }

    onInitialise() {
        this.clientId = this.route.parent.parent.snapshot.params['clientId'];
        this.siteId = getQueryParamFromAncestorRoute(this.route, 'siteId');

        this.subscriptions.push(this.route
            .queryParams
            .subscribe(queryParams => {
                if (+queryParams['highConsumptionPage']) {
                    this.page = +queryParams['highConsumptionPage'];
                } else { this.page = 1 }
            }));

        this.getData();       
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    isValidDate(item: any): boolean {
        let date = new Date(item.latestBillDate);
        let yearString = date.getFullYear().toString();
        if (yearString === "1" || item.latestBillDate == null) {
            return false;
        } else {
            return true;
        }
    }

    getPage(page: number) {
        this.page = page;
        this.getData();
    }

    getData() {
        this.issueService.getNoConsumptionDetail(this.clientId, this.page, this.pageSize, this.siteId).then((result) => {
            this.data = [];
            if (result && result.items && result.items.length > 0) {
                this.data = result.items;
                this.totalPages = result.totalPages;
                this.pageSize = result.pageSize;
                this.page = result.currentPage;
            } else { this.dataService.issuesNoConsumptionComponentResolved.next(false); }
        }, error => this.dataService.issuesNoConsumptionComponentResolved.next(false))
    }

    onInfoClick() {
        swal({
            title: 'Low consumption in last 30 days',
            html: '<p style="text-align: left;">This widget shows all meters which are providing readings but showing no consumption within the last 30 days.</p>\
            <p style="text-align: left;">This could mean that the meter is within a void property, indicative of a fault or due to consumer lifestyle choice.</p>',
            confirmButtonText: 'Close',
            confirmButtonColor: '#00539f'
        });
    }
}
